<template>
    <footer class="site-footer">
        <p>&copy; 2025 Koliklinikka<br />
        Vastaanotot Lohjalla ja Espoossa</p>
    </footer>
</template>

<script>
    export default {
        name: "SiteFooter"
    };
</script>

<style scoped>
    .site-footer, p {
        background-color: #82AC85;
        color: white;
        text-align: center;
        bottom: 0;
        width: 100%;
    }
</style>
